import { TourneeOperateurEdition } from './tournee-operateur-edition.model';
import { TourneeMouvementEdition } from './tournee-mouvement-edition.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class TourneeSiteEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        nom: { key: 'nom', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        ville: { key: 'ville', optional: true, default: '' },
        telephone: { key: 'telephone', optional: true, default: '' },
        operateur: { key: 'operateur', converter: new (ClassConverterFactory.build(TourneeOperateurEdition))(), optional: true },
        lots: { key: 'lots', converter: new (ArrayClassConverterFactory.build(TourneeMouvementEdition))(), optional: true, default: () => [] }
    };

    id: number;
    nom: string;
    adresse: string;
    codePostal: string;
    ville: string;
    telephone: string;
    operateur: TourneeOperateurEdition;
    lots: TourneeMouvementEdition[];
}
